import React, { useEffect, useState } from "react";
import { getAllColors, deleteColor } from "../../../api/colorService";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function ColorList() {
  const [colors, setColors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("desc");

  const navigate = useNavigate();

  const fetchColors = async () => {
    try {
      setLoading(true);

      const response = await getAllColors({ search, sort });

      const colorData = response?.data || response || [];

      const filteredColors = colorData.filter(
        (color) => !search || color.name?.toLowerCase().startsWith(search.toLowerCase()),
      );

      const sortedColors = [...filteredColors].sort((a, b) =>
        sort === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name),
      );

      setColors(sortedColors);
    } catch (error) {
      console.error("Error fetching colors:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchColors();
  }, [search, sort]);

  const handleDelete = async (id) => {
    try {
      await deleteColor(id);
      fetchColors();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="container-fluid p-4 np-color-options-page">
      <div className="card p-3">
        <div className="d-flex align-items-center justify-content-end pb-3 gap-2">
          <input
            type="text"
            className="form-control"
            style={{ width: "220px" }}
            placeholder="Search color..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select
            className="form-select border-0"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            style={{ width: "100px" }}
          >
            <option value="asc">ASC</option>
            <option value="desc">DESC</option>
          </select>

          <button
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => navigate("/color/add")}
          >
            <FaPlus />
            Add Color
          </button>
        </div>

        {loading ? (
          <div className="text-center py-3">Loading...</div>
        ) : (
          <table className="table table-bordered table-hover">
            <thead className="bg-light">
              <tr>
                <th className="text-dark fw-bold">#</th>
                <th className="text-dark fw-bold">Color Name</th>
                <th className="text-dark fw-bold">Hex Code</th>
                <th className="text-dark fw-bold">Status</th>
                <th className="text-dark fw-bold">Actions</th>
              </tr>
            </thead>

            <tbody>
              {colors.length > 0 ? (
                colors.map((color, index) => (
                  <tr key={color._id}>
                    <td>{index + 1}</td>

                    <td>{color.name}</td>

                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          width: "20px",
                          height: "20px",
                          backgroundColor: color.hexCode,
                          border: "1px solid #ccc",
                          marginRight: "8px",
                          verticalAlign: "middle",
                        }}
                      ></span>
                      {color.hexCode}
                    </td>

                    <td>
                      <span
                        className={`badge ${
                          color.status === "ACTIVE" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {color.status}
                      </span>
                    </td>

                    <td className="text-center d-flex justify-content-center gap-2">
                      <button
                        className="btn btn-sm np-table-action-btn"
                        onClick={() =>
                          navigate(`/color/view/${color._id}`, {
                            state: { colorId: color._id },
                          })
                        }
                      >
                        <FaEye />
                      </button>

                      <button
                        className="btn btn-sm np-table-action-btn"
                        onClick={() =>
                          navigate(`/color/edit/${color.name}`, {
                            state: { colorId: color._id },
                          })
                        }
                      >
                        <FaEdit />
                      </button>

                      <button
                        className="btn btn-sm np-table-action-btn"
                        onClick={() => handleDelete(color._id)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No colors found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}